import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "hi", "ar", "es", "fr"],
  defaultLocale: "en",
  localePrefix: "as-needed",
});
